import { Select } from 'antd';
import { useSelectedManager } from 'hooks';
import { filterOption } from 'helpers';

const SelectManager = () => {
	// Список менеджеров для селекта
	const {
		selectedManager,
		outstaffManagerList,
		handleManagerFetch
	} = useSelectedManager();

	return (
		<Select
			showSearch
			placeholder="Менеджеры"
			style={{ width: '100%' }}
			allowClear
			value={selectedManager || undefined}
			onChange={handleManagerFetch}
			options={outstaffManagerList}
			optionFilterProp="children"
			filterOption={filterOption}
		/>
	)
}

export default SelectManager;